import request from '@/utils/request'

// 客服消息添加
export function customeradd(data) {
  return request({
    url: '/workWechat/kfMsgV2/storeV2',
    method: 'post',
    data
  })
}

// 客服消息列表
export function workwechatlist(params) {
  return request({
    url: '/workWechat/kfMsgV2/index',
    method: 'get',
    params
  })
}

// 客服消息更新
export function workWechatupdata(data) {
  return request({
    url: '/workWechat/kfMsgV2/update',
    method: 'post',
    data
  })
}

// 客服消息删除
export function workWechatdestroy(data) {
  return request({
    url: '/workWechat/kfMsgV2/destroy',
    method: 'post',
    data
  })
}

/**
 * 新增素材
 * @param {Object} data 数据对象
 * @returns
 */
export function newMaterial(data = {}) {
  return request({
    url: '/sourceMaterial/store',
    method: 'post',
    data
  })
}
